import React from "react";
import "./Footer.css";
import Github from "../../assets/github.png";
import instagram from "../../assets/instagram.png";
import linkedin from "../../assets/linkedin.png";
import logo from "../../assets/logo.png";

const Footer = () => {
  return (
    <div className="footer-container">
      <div className="blur blur-footer"></div>
      <hr />
      <div className="footer">
        <div className="social">
          <img src={instagram} alt="" />
          <img src={linkedin} alt="" />
          <img src={Github} alt="" />
        </div>
        <div className="logo-f">
          <img src={logo} alt="" />
        </div>
      </div>
    </div>
  );
};

export default Footer;
